import { Component } from '@angular/core';

@Component({
  templateUrl: 'addparameter.component.html'
})
export class AddparameterComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/systems/addparameter.component.ts